import { render, staticRenderFns } from "./SearchTag.vue?vue&type=template&id=639f60ed"
import script from "./SearchTag.vue?vue&type=script&lang=js"
export * from "./SearchTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639f60ed')) {
      api.createRecord('639f60ed', component.options)
    } else {
      api.reload('639f60ed', component.options)
    }
    module.hot.accept("./SearchTag.vue?vue&type=template&id=639f60ed", function () {
      api.rerender('639f60ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/SearchTag.vue"
export default component.exports